import { render, staticRenderFns } from "./leave-employee.vue?vue&type=template&id=68442a40&scoped=true"
import script from "./leave-employee.vue?vue&type=script&lang=js"
export * from "./leave-employee.vue?vue&type=script&lang=js"
import style0 from "./leave-employee.vue?vue&type=style&index=0&id=68442a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68442a40",
  null
  
)

export default component.exports